<template>
    <div>
        <head>
            <meta charset="UTF-8">
            <!-- import CSS -->
            <link rel="stylesheet" href="https://unpkg.com/element-ui/lib/theme-chalk/index.css">
        </head>
        <header>
            <div class="col-12 " style="height: 100px; background-color: #007961;">
                <div class="d-flex justify-content-center">
                    <img src="../../assets/img/ardi_logo_white.svg" width="200" height="58" class="mt-4">
                </div>

            </div>
            <div class="col-12 " style="height: 10px; background-color: red;"></div>
        </header>
        <body>
            <div class="p-md-0 col-sm-11">
                <div class="form-font offset-sm-1">
                    <div class="p-md-0 ">
                        <b-col cols="12" offset="0" class="pl-md-4">
                            <!--USER-->
                            <template v-if="roleID == 1">
                                <b-row>

                                    <div class="col-12 mt-5 p-0">
                                        <div class="text-center" style="font-size: 20px;">
                                            <div style="color: #007961; " class="sm-text-header">მადლობას გიხდით ელექტრონული ხელმოწერისთვის!</div><br />
                                            <template v-for="(item,index) in data.clients" v-if="item.ID == 1">
                                                დაზღვეული: {{item.Name}}
                                                <!--(პ/ნ {{ item.Soccart }})<br />-->
                                                <template v-if="item.Name.includes('შპს')">
                                                    (ს/კ {{ item.Soccart }})
                                                    <br />
                                                </template>
                                                <template v-else>
                                                    (პ/ნ {{ item.Soccart }})
                                                    <br />
                                                </template>
                                            </template>
                                        </div>

                                        <div class="mt-5 text-center">
                                            სს "პროკრედიტ ბანკის" ავტოსესხის უზრუნველყოფაში არსებული ავტომობილის საკრედიტო დაზღვევის გააქტიურებულ პოლისს 
                                            მიიღებთ ბანკის წარმომადგენლის მიერ პოლისის დადასტურებისთანავე
                                        </div>
                                        <div class="mt-5 border mb-5 col-md-8 offset-md-2" style="border-radius:16px">
                                            <div class="d-md-flex d-lg-flex justify-content-between m-3">

                                                <div class="d-md-flex d-lg-flex pl-lg-5 pl-md-5">
                                                    <img :src="this.photo" height="84" class="img_radius sm-photo">
                                                    <div class="pl-lg-5 pl-md-5 mt-3 sm-config">
                                                        სადაზღვევო მრჩეველია:<br />
                                                        <span style="color: #007961">{{data.policyInfo[0].NMG_NAME_A}} {{data.policyInfo[0].MNG_LASTNAME}}</span>
                                                    </div>

                                                </div>
                                                <div class="pr-md-5 mt-3 sm-config">
                                                    <i class="el-icon-phone custom-icon" style="color: rgb(0, 121, 97);"></i> {{data.policyInfo[0].MNG_PHONE}}<br />
                                                    <i class="el-icon-message custom-icon" style="color: rgb(0, 121, 97);"></i> {{data.policyInfo[0].MNG_EMAIL}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </b-row>
                            </template>
                            <!--BANK-->
                            <template v-else-if="roleID == 2 || roleID == 0">
                                <b-row>
                                    <div class="col-12 mt-5 p-0">
                                        <div class="text-center">
                                            <div style="color: #007961" class="sm-text-header">მადლობას გიხდით ელექტრონული ხელმოწერისთვის!</div><br />

                                            სს „პროკრედიტ ბანკის“ ავტოსესხის უზრუნველყოფაში<br />
                                            არსებული ავტომობილი უკვე დაზღვეულია
                                            <template v-if="roleID == 2">
                                                <div class="mt-5">
                                                    პოლისი დოკუმენტური სახით გამოიგზავნება ბანკის ელ-ფოსტაზე
                                                </div>
                                            </template>
                                            <template v-else=" roleID == 0">
                                                <div class="mt-5">
                                                    პოლისი დოკუმენტური სახით გამოიგზავნება როგორც ბანკის, ისე მსესხებლის ელ-ფოსტაზე
                                                </div>
                                            </template>

                                        </div>

                                        <div class="mt-5 border mb-5 col-md-8 offset-md-2" style="border-radius:16px">
                                            <div class="d-md-flex d-lg-flex  justify-content-between m-3">
                                                <div class="sm-config pl-md-5 mt-2">
                                                    <div style="font-weight:bold">დამზღვევი</div>
                                                    <span style="color: #007961">{{data.policyInfo[0].CUSTOMERNAME}}</span>
                                                </div>
                                                <div class="sm-config mt-2">
                                                    <div style="font-weight:bold">პოლისის ნომერი</div>
                                                    <span>{{data.policyInfo[0].POLICYPRODUCT}}</span>
                                                </div>
                                                <div class="sm-config pr-md-5 mt-2">
                                                    <div style="font-weight:bold">მოქმედების ვადა</div>
                                                    <span>{{data.policyInfo[0].FROMDATE}} - {{data.policyInfo[0].TODATE}}</span>
                                                </div>
                                            </div>

                                        </div>

                                        
                                        <div class="mt-5 border mb-5 col-md-8 offset-md-2" style="border-radius:16px">
                                            <div class="d-md-flex d-lg-flex justify-content-between m-3">

                                                <div class="d-md-flex d-lg-flex pl-lg-5 pl-md-5">
                                                    <img :src="this.photo" height="84" class="img_radius sm-photo">
                                                    <div class="pl-lg-5 pl-md-5 mt-3 sm-config">
                                                        სადაზღვევო მრჩეველია:<br />
                                                        <span style="color: #007961">{{data.policyInfo[0].NMG_NAME_A}} {{data.policyInfo[0].MNG_LASTNAME}}</span>
                                                    </div>

                                                </div>
                                                <div class="pr-md-5 mt-3 sm-config">
                                                    <i class="el-icon-phone custom-icon" style="color: rgb(0, 121, 97);"></i> {{data.policyInfo[0].MNG_PHONE}}<br />
                                                    <i class="el-icon-message custom-icon" style="color: rgb(0, 121, 97);"></i> {{data.policyInfo[0].MNG_EMAIL}}
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                </b-row>
                            </template>

                        </b-col>
                    </div>
                </div>
            </div>
        </body>

        <footer class="footer">
            <div class="col-12 p-0">
                <div class="success_footerPcb">
                    <!--style="padding-top:23%"-->
                    <div class="d-flex justify-content-between  text-md">
                        <div style="color:azure;padding-left:3%">
                            T: 2 10 10 10 <br />
                            www.ardi.ge
                        </div>
                        <img src="../../assets/img/success_footer_text1.png" width="220" height="30" style="padding-right: 31px; margin-top: 10px; ">
                    </div>

                </div>
            </div>
        </footer>

    </div>
</template>

<script src="https://unpkg.com/vue/dist/vue.js"></script>
<!-- import JavaScript -->
<script src="https://unpkg.com/element-ui/lib/index.js"></script>

<script>
    //import Signature from "@/Procredit/components/Signature";
    export default {
        props: ['rowid', 'cont', 'cust', 'roleID'],
        name: "Contract",
        components: {
            
        },
        data() {
            return {
                data: null,
                photo: '',
            }
        },
        mounted() {
            this.$http.get(`/policy/GetPcbPolicyInfo/${this.cont}/${this.cust}`).then(r => {
                this.data = r.data;
                this.photo = r.data.policyInfo[0].MNG_PHOTO;
                console.log("GetPcbPolicyInfo", r.data);
            }).catch((e) => {
                console.log(e)
            })
        },
        methods: {
            openLink: function (url) {
                window.open(url, "_blank");
            }
        }
    }
</script>

<style scoped>
    @import "~bpg-nino-mtavruli";

    .custom-icon {
        font-size: 22px;
    }

    .nino-mtavruli {
        font-family: "BPG Nino Mtavruli", sans-serif;
    }

    .footer {
        position: relative;
        left: 0;
        bottom: 0;
        width: 100%;
    }

    .border-green {
        border: 2px solid #00a987 !important;
    }

    .pol-number {
        font-size: 17px;
        font-weight: bold;
    }

    .header-text {
        font-size: 24px;
        font-weight: bold;
        color: #007961;
    }

    .description-box {
        background-color: #00a987;
        color: #fff;
    }

    .print-body {
        margin-bottom: 5rem;
    }

    .value-background {
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .value-background-rb {
        border-bottom: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .value-background-lrb {
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .border-mn {
        border: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .content-header {
        background-color: #005745;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
    }

    .content-header1 {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
    }

    .description {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
    }

    .description-top {
        background-color: #00A788;
        color: #fff;
        font-weight: bold;
    }


    .border-bottom-mn {
        border-bottom: 1px solid #b0b1b3 !important;
    }

    .border-right-mn {
        border-right: 1px solid #b0b1b3 !important;
    }



    .print-body {
        margin-bottom: 5rem;
    }

    .payment-block {
        width: 51%;
    }

    table {
        width: 100%;
    }


    .pay-border-left {
        border-left: 1px solid #41A546;
    }

    .pay-head-border {
        border-collapse: collapse;
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
    }


    #print-header {
        padding: 15px 0;
        display: table-header-group;
    }


    .payment-md-border {
        border: 1px solid #00A886;
        border-collapse: collapse;
        font-size: 10pt;
    }

    .md-text {
        width: 71%
    }

    .img_radius {
        border-radius: 50%;
    }

    .height-sm {
        height: 66px;
    }

    .text-md {
        padding-top: 200px;
    }

    .sm-text-header {
        font-size: 28px;
    }

    @media (max-width: 500px) {
        .header_logo_property {
            width: 100%;
        }

        .sm-text-header {
            font-size: 22px;
        }

        .sm-text {
            width: 100%
        }

        .hide-logo-sm {
            display: none;
        }

        .height-sm {
            height: 77px;
        }

        .footer {
            position: unset;
        }

        .sm-config {
            text-align: center !important;
        }

        .sm-photo {
            display: block;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>